<template>
  <div class="period-select" :class="{ 'period-select--light': light }">
    <select class="period-select__input" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)">
      <optgroup label="Meses">
        <option v-for="opt in months" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </optgroup>
      <optgroup label="Trimestres">
        <option v-for="opt in quarters" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </optgroup>
      <optgroup label="Año" v-if="currentYear">
        <option :value="currentYear.value">{{ currentYear.label }}</option>
      </optgroup>
    </select>
    <span class="mdi mdi-chevron-down period-select__arrow"></span>
  </div>
</template>

<script setup>
defineProps({
  modelValue: String,
  months: { type: Array, default: () => [] },
  quarters: { type: Array, default: () => [] },
  currentYear: { type: Object, default: null },
  // Fondo navy más claro (#24487a) para distinguir el selector de comparación del principal
  light: { type: Boolean, default: false },
})

defineEmits(['update:modelValue'])
</script>

<style scoped>
.period-select {
  position: relative;
  display: flex;
  align-items: center;
  height: 32px;
}

.period-select__input {
  appearance: none;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 6px;
  color: #ffffff;
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 0.82rem;
  height: 32px;
  padding: 0 1.8rem 0 0.7rem;
  cursor: pointer;
}

.period-select__input option,
.period-select__input optgroup {
  color: var(--text-content);
  background: #ffffff;
}

.period-select--light .period-select__input {
  background: #24487a;
  border-color: rgba(255, 255, 255, 0.3);
}

.period-select__input:hover {
  border-color: rgba(255, 255, 255, 0.45);
}

.period-select__arrow {
  position: absolute;
  right: 0.5rem;
  color: #ffffff;
  font-size: 0.9rem;
  pointer-events: none;
}
</style>